import * as countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

// Register only the English locale, once, at module load.
countries.registerLocale(enLocale);

/**
 * Converts a country name to its ISO 3166-1 alpha-2 code (e.g. "Ukraine" -> "UA").
 *
 * The input is trimmed and lowercased before lookup. Returns `undefined` when the
 * name cannot be resolved to a code.
 */
export function getCountryCode(name: string): string | undefined {
  const normalized = name?.trim().toLowerCase();

  if (!normalized) {
    return undefined;
  }

  return countries.getAlpha2Code(normalized, 'en') || undefined;
}
